/**
 * Bản dịch VI của `pricePane.messages.en.ts`. Giữ cùng cấu trúc và cùng bộ key —
 * `__tests__/pricePaneHeaderI18n.test.ts` AC-9.1/9.2 kiểm cả hai vế.
 */
export const pricePaneMessagesVi = {
    "pricePaneHeader.searchSymbol": "Nhấn để tìm mã",
    "pricePaneHeader.linkGroup": "Nhóm liên kết mã {group}",
    "pricePaneHeader.chartSettings": "Cài đặt biểu đồ",
};
